import React, { useState, useEffect } from 'react'
import http from '../../config/BaseUrl'
import Layout from '../../components/layouts/Layout'
import ScreenLoader from '../../components/Loader/ScreenLoader'

function MemberSettings() {

  const [isLoading, setLoading] = useState(false)
  const [loadingContent, setLoadingContent] = useState(null)
  const [loadedContent, setLoadedContent] = useState(null)
  const [memberSetting, setMemberSetting] = useState(null)
  const [name, setName] = useState('exit_app')
  const [active_status, setActiveStatus] = useState(false)
  const [adminPassword, setAdminPassword] = useState(new Array(4).fill(""));



  useEffect(() => {
    setLoading(true)
    setLoadingContent("Loading. Please Wait.")
    http.get('get-member-settings')
      .then(res => {
        setLoadingContent("Loaded.")
        if (res.data.memberSettings) {
          setActiveStatus(res.data.memberSettings.active_status)
          if (res.data.memberSettings.password) {
            setAdminPassword((res.data.memberSettings.password).split(""))
          }
        }
        setMemberSetting(res.data.memberSettings)
        setTimeout(() => {
          setLoading(false)
        }, 1000)
      })


  }, [])

  const submitChanges = (e) => {
    e.preventDefault();
    setLoading(true)
    setLoadingContent("Saving. Please Wait.")
    const submittedData = {
      name: name,
      active_status: active_status,
      password: adminPassword?.toString().replace(/,/g, "")
    }

    http.post('member-settings', submittedData)
      .then(res => {
        setLoadingContent("Saved.")
        setTimeout(() => {
          setLoading(false)
        }, 1000)
      })
      .catch(err => {
        console.log(err.response)
        setLoadingContent("Somthing went wrong.")
        setTimeout(() => {
          setLoading(false)
        }, 1000)
      })
  }

  const handleChange = (element, index) => {
    if (isNaN(element.value)) return false;
    setAdminPassword([...adminPassword.map((d, idx) => (idx === index ? element.value : d))]);
  };

  const handleKeyPress = (e, index) => {
    if(e.keyCode === 8){
        if(e.target.previousSibling){
            e.target.previousSibling.focus();
        }
    }
    else{
        if (e.target.nextSibling) {
            e.target.nextSibling.focus();
        }
    }
  }

  return (
    <Layout>
      {
        !isLoading ?
          <div className="page">
            <div className="card radius-15">
              <div className="card-content">
                <div className="card-header">
                  <h4 className="font-weight-bold">Member Settings</h4>
                </div>
                <form onSubmit={submitChanges}>
                  <div className="card-body">
                    <div className="settings">
                      <div className="settings-item d-flex justify-content-lg-between">
                        <div className="settings-title">
                          <h5>Exit From App</h5>
                          <input type="hidden" name="name" value="exit_app" />
                        </div>
                        <div className="custom-control custom-switch">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="customSwitch1"
                            checked={active_status == 1 ? true : false}
                            onChange={e => {
                              if (e.target.checked) {
                                setActiveStatus(1)
                              }
                              else {
                                setActiveStatus(0)
                              }
                            }}
                          />
                          <label className="custom-control-label" for="customSwitch1"></label>
                        </div>
                      </div>
                      <div className="settings-item d-flex justify-content-lg-between mt-3">
                        <div className="settings-title">
                          <h5>PIN</h5>
                        </div>
                        <div className="pin">
                          <div className="d-flex">
                            {adminPassword && adminPassword.map((data, index) => (
                              < input
                                className="form-control"
                                type="text"
                                maxLength="1"
                                key={index}
                                value={data}
                                onKeyUp={e => handleKeyPress(e, index)}
                                onChange={e => handleChange(e.target, index)}
                                onFocus={e => e.target.select()}
                              />
                            )
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer text-right">
                    <button type="submit" className="btn btn-primary">Save Changes</button>
                  </div>
                </form>
              </div>

            </div>

          </div>
          : <ScreenLoader loadingContent={loadingContent} loaded={loadedContent} />
      }


    </Layout>
  )
}

export default MemberSettings
